import React from 'react'
// import PropTypes from 'prop-types'
import { Translate } from 'utils/localize'
import { OmegaClonePurchasedModel } from 'models/recruit/RewardListModel'
import Achievement from './components/achievement'
import style from './Achievements.module.scss'

interface Props {
    omegaClonePurchased: OmegaClonePurchasedModel
}

const Achievements = ({ omegaClonePurchased }: Props): JSX.Element => {
    // TODO: have array and map through.
    // if (!omegaClonePurchased) return null

    return (
        <Translate>
            {({ translate }) => (
                <div className={style.achievements}>
                    {omegaClonePurchased?.rewards?.TotalRecruitsOne ? (
                        <Achievement
                            count={1}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsOne.toString()}
                            tooltip={translate('recruit.tooltips.one.enabled')}
                        />
                    ) : (
                        <Achievement
                            count={1}
                            achieved={false}
                            tooltip={translate('recruit.tooltips.one.disabled')}
                        />
                    )}

                    {omegaClonePurchased?.rewards?.TotalRecruitsTwo ? (
                        <Achievement
                            count={2}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsTwo.toString()}
                            tooltip={translate('recruit.tooltips.two.enabled')}
                        />
                    ) : (
                        <Achievement
                            count={2}
                            achieved={false}
                            tooltip={translate('recruit.tooltips.two.disabled')}
                        />
                    )}

                    {omegaClonePurchased?.rewards?.TotalRecruitsFive ? (
                        <Achievement
                            count={5}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsFive.toString()}
                            tooltip={translate('recruit.tooltips.five.enabled')}
                        />
                    ) : (
                        <Achievement
                            count={5}
                            achieved={false}
                            tooltip={translate(
                                'recruit.tooltips.five.disabled'
                            )}
                        />
                    )}

                    {omegaClonePurchased?.rewards?.TotalRecruitsTen ? (
                        <Achievement
                            count={10}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsTen.toString()}
                            tooltip={translate('recruit.tooltips.ten.enabled')}
                        />
                    ) : (
                        <Achievement
                            count={10}
                            achieved={false}
                            tooltip={translate('recruit.tooltips.ten.disabled')}
                        />
                    )}

                    {omegaClonePurchased?.rewards?.TotalRecruitsTwenty ? (
                        <Achievement
                            count={20}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsTwenty.toString()}
                            tooltip={translate(
                                'recruit.tooltips.twenty.enabled'
                            )}
                        />
                    ) : (
                        <Achievement
                            count={20}
                            achieved={false}
                            tooltip={translate(
                                'recruit.tooltips.twenty.disabled'
                            )}
                        />
                    )}

                    {omegaClonePurchased?.rewards?.TotalRecruitsFourty ? (
                        <Achievement
                            count={40}
                            achieved
                            date={omegaClonePurchased.rewards.TotalRecruitsFourty.toString()}
                            tooltip={translate(
                                'recruit.tooltips.fourty.enabled'
                            )}
                        />
                    ) : (
                        <Achievement
                            count={40}
                            achieved={false}
                            tooltip={translate(
                                'recruit.tooltips.fourty.disabled'
                            )}
                        />
                    )}
                </div>
            )}
        </Translate>
    )
}

// Achievements.propTypes = {
//     achievements: PropTypes.any, //eslint-disable-line
// }

export default Achievements
